export const SET_OPENING_HOURS = 'actions/places/SET_OPENING_HOURS'
export const CHANGE_FORM_VALUE = 'actions/places/CHANGE_FORM_VALUE'
export const LOAD_EDIT_PLACE = 'actions/places/LOAD_EDIT_PLACE'
export const CHANGE_FORM_VALUE_TRANSLATION = 'actions/places/CHANGE_FORM_VALUE_TRANSLATION'